
import Select from 'react-select';
import { useEffect, useState } from 'react';
import CustomMultiSelect from '../CustomMultiSelect/CustomMultiSelect';
import { get, post } from '../../services/api';
import { logout } from '../../auth';
import { useNavigate } from 'react-router-dom';
import { parseObjectToURLQuery } from '../../utils'


export default function FiltrosListarCluster({ filtros, setFiltros, setCluster, setLoad}) {
    const navigate = useNavigate()

    const [ clustersSelecionados, setClustersSelecionados ] = useState(null);
    const [ optionsCluster, setOptionsCluster ] = useState([]);
    const [ optionsFilial, setOptionsFilial ] = useState([]);


    async function setOptionsClusterWithRequest(authToken) {
        try {
            const clusters = await get('/admin/metas/cluster', null, authToken)
            setOptionsCluster(clusters.map(cluster => ({ 
                label: cluster.cluster, 
                value: cluster.id_cluster 
            })))

            return clusters
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    async function setOptionsFilialWithRequest() {
        try {
            const requisicao = { idRegiao: 0, habilitadas: false };
            const filiais = await post('/vendedores/filiais', requisicao);   

            const options = [
                { label: 'Todas', value: 0 },
                ... filiais.map(filial => ({
                    value: filial.cod_sabium,
                    label: filial.cod_sabium - 10000 + ' - ' + filial.nome,
                }))
            ];
            
            setOptionsFilial(options);

            return filiais;
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    async function filtrarHandler(authToken = authTokenState) {
        try {
            setLoad(true)
            const clusters = await get(`/admin/cluster/listarcluster?${parseObjectToURLQuery({
                id_cluster: filtros.id_cluster
            })}`, null, authToken);

            setCluster(clusters.dados);

            setLoad(false)
            return clusters;
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    useEffect(() => {
        const authToken = localStorage.getItem("adminToken")

        if(authToken == null) {
            logout();
            navigate("/login");
            return;
        }

        setAuthTokenState(authToken);

        Promise.all([
            setOptionsClusterWithRequest(authToken),
            setOptionsFilialWithRequest(),
        ]).then(() => filtrarHandler(authToken))
    }, [])

    
   

    //Utils
    const [ authTokenState, setAuthTokenState ] = useState(undefined);
    const mensagemNenhumaOpcaoAlternativa = () => 'Nenhuma opção disponível';
    

    return <>
        <div className="flex gap-4 items-end flex-wrap" style={{margin: '15px'}}>
            <div style={{marginBottom: '15px'}}>
                <div className='id_cluster-wrapper'>
                    <label htmlFor="id_cluster">Cluster</label>
                    <CustomMultiSelect
                        selectedOptions={clustersSelecionados}
                        setSelectedOptions={setClustersSelecionados}
                        onChange={(cluster) => { 
                            setFiltros((filtros) => ({
                                ... filtros,
                                id_filiais: 0,
                                id_cluster: cluster
                            }))
                        }}
                        filteredOptions={optionsCluster}
                        placeholder={'Selecione o Cluster'}
                    />
                </div>
            </div>
            <div style={{width: '280px', marginBottom: '15px'}}>
                <label htmlFor="id_filiais">Buscar por filial</label>
                <Select
                    name="id_filiais"
                    className="react-select"
                    classNamePrefix="react-select"
                    value={optionsFilial.find(opt => opt.value == filtros.id_filiais)}
                    onChange={(filial) => { 
                        setFiltros((filtros) => ({
                            ... filtros,
                            id_filiais: filial.value
                        }))
                    }}
                    options={optionsFilial}
                    placeholder={'Filiais'}
                    required
                    isSearchable={false}
                    noOptionsMessage={mensagemNenhumaOpcaoAlternativa}
                />
            </div>

            
            <button className="admin-accept-btn" style={{marginBottom: '15px'}} onClick={() => filtrarHandler()}>Filtrar</button>
        </div>
            
    </>
}
